import { ValidPropText } from './ValidInputText';
import { ValidMultiFieldTextProp } from './ValidMultiFieldText';

export const scrubValue = (prop: ValidPropText): string => (typeof prop.val === 'string' ? prop.val.trim() : '');

export const validateZipCode = (prop: ValidPropText): boolean => {
    prop.err = '';
    const val = scrubValue(prop).replace(/-/g, ''); // Remove hyphens for validation
    if (!val || val.length < 5 || val.length > 9) {
        prop.err = '5 or 10 numbers with format: "12345-1234"';
        return false;
    }
    return true;
};

export const validatePhone = (prop: ValidPropText): boolean => {
    prop.err = '';
    const val = scrubValue(prop).replace(/-/g, ''); // Remove hyphens for validation
    if (!val || val.length < 10 || val.length > 10) {
        prop.err = 'Required, please enter a valid phone/fax number.';
        return false;
    }
    return true;
};

export const validateMedType = (prop: ValidPropText): boolean => {
    prop.err = '';
    const val = scrubValue(prop);

    if (!val) {
        prop.err = 'Required, please select a type.';
        return false;
    }
    return true;
};

export const validateBIN = (prop: ValidPropText): boolean => {
    prop.err = '';
    const val = scrubValue(prop);
    const regex = new RegExp(/[a-zA-Z]/);

    if (!val) {
        prop.err = 'Required, 6 digit number.';
        return false;
    } else if (val.length < 6 || val.length > 6) {
        prop.err = 'BIN does not meet 6 digit requirement.';
        return false;
    } else if (regex.test(val)) {
        prop.err = 'BIN can only consist of integers.';
        return false;
    }
    return true;
};

export const validateNPI = (prop: ValidPropText): boolean => {
    prop.err = '';
    const val = scrubValue(prop);
    const regex = new RegExp(/[a-zA-Z]/);

    if (val && (val.length < 3 || val.length > 15)) {
        prop.err = 'NPI must be 3 to 15 characters in length.';
        return false;
    } else if (regex.test(val)) {
        prop.err = 'NPI can only consist of integers.';
        return false;
    }
    return true;
};

export const validatePCNOrGroupNumber = (prop: ValidPropText): boolean => {
    prop.err = '';
    const val = scrubValue(prop);

    if (val && (val.length < 2 || val.length > 20)) {
        prop.err = 'Optional, 2 to 20 characters.';
        return false;
    }
    return true;
};

type ValidateFieldByLengthArgs = {
    prop: ValidPropText;
    minLength?: number;
    maxLength?: number;
    required?: boolean;
};

export const validateFieldByLength = ({
    prop,
    minLength,
    maxLength,
    required = false,
}: ValidateFieldByLengthArgs): boolean => {
    prop.err = '';
    const val = scrubValue(prop);

    if (!val && required) {
        prop.err = 'Required';
        return false;
    } else if (!val && !required) {
        return true;
    }

    if (minLength !== undefined && val.length < minLength) {
        prop.err = `Must be at least ${minLength} characters${maxLength !== undefined ? ` and no more than ${maxLength} characters` : ''}`;
        return false;
    }
    if (maxLength !== undefined && val.length > maxLength) {
        prop.err = `Must be ${minLength !== undefined ? `at least ${minLength} characters and ` : ''}no more than ${maxLength} characters`;
        return false;
    }
    return true;
};

type ValidateFieldByQuantityArgs = {
    prop: ValidMultiFieldTextProp;
    minQuantity?: number;
    maxQuantity?: number;
    required?: boolean;
};

export const validateFieldByQuantity = ({
    prop,
    minQuantity,
    maxQuantity,
    required = false,
}: ValidateFieldByQuantityArgs): boolean => {
    prop.err = '';
    const val = prop.val;

    if (!required) {
        prop.err = '';
        return true;
    }

    if (!val || (minQuantity !== undefined && val.length < minQuantity && required)) {
        prop.err = `Required, minimum of ${minQuantity} item(s)`;
        return false;
    }
    if (maxQuantity !== undefined && val.length > maxQuantity && required) {
        prop.err = `Required, maximum of ${maxQuantity} items`;
        return false;
    }
    return true;
};
